import React, { useRef, useState } from 'react';

import { useLazyQuery } from '@apollo/react-hooks';
import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';
import { Client } from '@netfront/gelada-react-shared';
import { addMonths, isValid } from 'date-fns';
import { useParams } from 'react-router-dom';

import ExportPage from './ExportPage';
import Constants from './Shared/Constants';

import { getSignedUrl } from '../../../middleware/AWS/getSignedUrl';
import { EXPORT_LOGINS } from '../../../middleware/Export/exportLogins';
import { downloadFileByUrl } from '../../../utils/utils';

const ExportLoginsPage = () => {
  const { projectId } = useParams();

  const client = useRef(Client()).current;

  const [apiError, setApiError] = useState(undefined);
  const [dateFrom, setDateFrom] = useState(addMonths(new Date(), -1));
  const [dateTo, setDateTo] = useState(new Date());
  const [isFormValid, setIsFormValid] = useState(true);

  const [sendExportLoginsQuery, { loading: isGeneratingReport }] = useLoggedGeladaLazyQuery({
    query: EXPORT_LOGINS,
    options: {
      client,
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        const { contentType, s3Key } = data.report.exportLogins;
        const signedUrl = getSignedUrl(s3Key, contentType);

        downloadFileByUrl(signedUrl);
      },
      onError: (error) => {
        setApiError(error);
      },
    },
  });

  const download = (fileType = 'EXCEL' | 'CSV') => {
    sendExportLoginsQuery({
      variables: {
        dateFrom,
        dateTo,
        ianaTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        projectId,
        fileType,
      },
    });
  };

  const handleDateFromChange = (value) => {
    setDateFrom(value);
    setIsFormValid(isValid(dateFrom) && isValid(dateTo));
  };

  const handleDateToChange = (value) => {
    setDateTo(value);
    setIsFormValid(isValid(dateFrom) && isValid(dateTo));
  };

  const options = {
    apiError,
    downloadCSVCallback: () => download('CSV'),
    downloadExcelCallback: () => download('EXCEL'),
    filtering: {
      date: {
        dateFrom,
        dateTo,
        handleDateFromChangeCallback: handleDateFromChange,
        handleDateToChangeCallback: handleDateToChange,
      },
    },
    flags: {
      isFormValid,
      preloader: {
        isGeneratingReport,
      },
    },
    infoBannerText: 'This page exports logins based on the selected filters',
  };

  return <ExportPage options={options} />;
};

export default ExportLoginsPage;
